import { render, staticRenderFns } from "./serviceJudge.vue?vue&type=template&id=084e70b2&scoped=true"
import script from "./serviceJudge.vue?vue&type=script&lang=js"
export * from "./serviceJudge.vue?vue&type=script&lang=js"
import style0 from "./serviceJudge.vue?vue&type=style&index=0&id=084e70b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e70b2",
  null
  
)

export default component.exports